import { Box, Checkbox, Typography } from "@material-ui/core";

export default function RepresentativeCard({
  representative,
  checked,
  onChange,
}) {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Checkbox checked={checked} onChange={onChange} />
      <Typography
        variant="h6"
        style={{
          fontSize: "1rem",
          textTransform: "uppercase",
          margin: 0,
          color: "gray",
        }}
      >
        {representative.Nome}
      </Typography>
    </Box>
  );
}
